export default __webpack_public_path__ + "static/Icono_vertical_portada_libro-1bf0c053c29678715e9506d266f31b60.jpg";